import axios from 'axios'
import store from '@/store'

import jwtDecode from 'jwt-decode'

import {TOKEN} from 'common/const'
import * as types from '@/store/mutation-types'

// axios.defaults.withCredentials=true;

// create an axios instance
const instance = axios.create({
  // baseURL: baseUrl,
  baseURL: process.env.VUE_APP_BASE_API,
  // timeout: 5000
	headers: {
	  'Content-Type': "application/json;charset=utf-8"
	},
    withCredentials: true,
    crossDomain: true
})

// request interceptor
instance.interceptors.request.use(
  config => {
    // do something before request is sent
    // 请求头添加token
    config.headers[TOKEN] = store.state.user.authorization
    config.headers['x-user']=localStorage.getItem('x-user')
    return config
  },
  error => {
    // do something with request error
    console.log('Error: '+error.message)  // for debug
    return Promise.reject(error)
  }
)

// response interceptor
instance.interceptors.response.use(
  response => {
    // 响应成功，更新token
    const res = response.data
    // console.log("response:",response)
    if (res === null || res === '') {
      // res为空，表示请求被拦截，token失效
      // store.commit(types.USER_MODULE + types.UPDATE_TOKEN, '')
    } else if (res.hasOwnProperty(TOKEN)) {
      // 响应含有token，进行更新
      let token = res.authorization
      // 判断token是否正确，不正确则重置为空
      try {
        jwtDecode(token);
      } catch(error) {
        console.log('Error: '+error.message)
        token = ''
      } finally {
        store.commit(types.USER_MODULE + types.UPDATE_TOKEN, token)
        localStorage.setItem(TOKEN, token)
      }
    }
    return res
  },
  error => {
    // 响应失败
    let status=error.response.status
    if(status==401){
        //token 失效
        console.log("token expired")
        localStorage.setItem(TOKEN, '')
        store.commit(types.USER_MODULE + types.UPDATE_TOKEN, '')
        location.reload()
    }
    return Promise.reject(error)
  }
)

export default instance
